import React, { createContext } from 'react';

const UsersContext = createContext();

export default UsersContext;